import styled, { css } from 'styled-components'

import { hiddenScrollbar, media } from '@/theme/common'

export const ScrollWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['4']};
    flex: 1;
    min-width: 0;

    ${media.down('sm')} {
      > button:first-child,
      > button:last-child {
        min-width: 0;
        padding: 0;
      }
    }
  `,
)

// Note: min-width: 0 here is load-bearing - without it, this flex item's automatic
// minimum width falls back to Container's full (unscrolled) content width and it
// overflows ScrollWrapper instead of letting Container handle the overflow internally.
export const ScrollableArea = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const Container = styled.div(
  () => css`
    ${hiddenScrollbar}

    align-items: center;
    display: flex;
    overflow-x: auto;
  `,
)

interface TabProps {
  $active: boolean
  $disabled: boolean
}

export const Tab = styled.button<TabProps>(({ theme, $active, $disabled }) => ({
  '&:hover:not(:disabled)': {
    borderBottom: `${theme.border.size['2']} solid ${theme.colors.black500}`,
  },
  alignItems: 'center',
  background: 'transparent',
  border: 'none',
  borderBottom: `${theme.border.size['2']} solid ${$active ? theme.colors.black800 : 'transparent'}`,
  color: $active ? theme.colors.black800 : theme.colors.black500,
  cursor: 'pointer',
  display: 'flex',
  fontSize: '1.2rem',
  fontWeight: 500,
  gap: theme.space['10'],
  opacity: $disabled ? 0.5 : 1,
  padding: `${theme.space['6']} ${theme.space['8']} ${theme.space['4']}`,
  textTransform: 'capitalize',
  transition: `all ${theme.transition.duration.sm} ease`,
  whiteSpace: 'nowrap',

  // Note: same tighter-mobile-spacing pattern as the rest of the toolbar (ui/table cell padding,
  // TableGroup's Card, navbar-menu's nav labels) - halves the horizontal padding, which is also
  // what's making adjacent tabs sit closer together since Container has no gap of its own between
  // them (the space between tabs is entirely each Tab's own left/right padding).
  [media.down('sm')]: {
    gap: theme.space['4'],
    padding: `${theme.space['6']} ${theme.space['4']} ${theme.space['4']}`,
  },
}))
